import type { RequestAction } from "trystero";
import { decodeBoundedRoomPacket, encodeRoomPacket } from "./room-packet.js";

export async function requestRoomPacket<T>(
  action: RequestAction<string, string>,
  value: unknown,
  peerId: string,
): Promise<T> {
  const raw = await action.request(encodeRoomPacket(value), { target: peerId, timeoutMs: 5_000 });
  return decodeBoundedRoomPacket<T>(raw);
}
